import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import './BabySizeComparison.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";

import Right from '../../right/Right';
import Service from '../../service/Service';
import WeekSlider from '../common/WeekSlider';
import ShareIcon from '../common/ShareIcon';
const service = new Service();

class BabySizeComparison extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let babysizecomparisonData = [];
        let currentweek = 4;
        let imageUrl='';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            if (window.__initialData__['initialData']['result']) {
                babysizecomparisonData = window.__initialData__['initialData']['result']
            }
            if (window.__initialData__['initialData']['currentWeekNo']) {
                currentweek = window.__initialData__['initialData']['currentWeekNo']
            }
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
                if (props.staticContext.initialData['initialData']['result']) {
                    babysizecomparisonData = props.staticContext.initialData['initialData']['result']
                }
                if (props.staticContext.initialData['initialData']['currentWeekNo']) {
                    currentweek = props.staticContext.initialData['initialData']['currentWeekNo'];
                    imageUrl=props.staticContext.initialData['initialData']['result'][currentweek-4]['fruitUrl'];
                }
            }
        }
        this.state = {
            initialData: initialData,
            week: '',
            weekno: '',
            selectedtype: '',
            babysizecomparisonData: babysizecomparisonData,
            articlesData: [],
            clickwedWeek: currentweek,
            scrollwidth: '',
            halfwidth: '',
            weekwd: '',
            weeks: '',
            imageUrl:imageUrl,
            Descreption1:'',
            typename: '',
            currentweek: currentweek,
            IsExpected: false,
            marginRight: 20,
            sliderWidth: 309,
            sliderFullWidth: '987px'
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': global.ftk,
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "comparison/getsizebytype";
        let body = JSON.stringify({})
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        document.addEventListener("click", actions.domClick);
        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (global.ftk != '') {
            document.querySelector(".useNameDyn").innerHTML = " for (" + global.userAry['userName'] + ")";
        }
        if (window.innerWidth < 768) {
            this.setState({ marginRight: 10, sliderWidth: 230, sliderFullWidth: '720px' });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.getBabySizeComparisonData();
            } else {
                localStorage.setItem('BabySizeComparisonData', JSON.stringify(this.state.initialData));
                this.loadBabySizeComparison();
                this.loadStateData();
            }
        } else {
            if (localStorage.getItem('BabySizeComparisonData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('BabySizeComparisonData')),
                    babysizecomparisonData: JSON.parse(localStorage.getItem('BabySizeComparisonData'))['result'],
                    currentweek: JSON.parse(localStorage.getItem('BabySizeComparisonData'))['currentWeekNo'] ? JSON.parse(localStorage.getItem('BabySizeComparisonData'))['currentWeekNo'] : 4,
                });
                this.loadBabySizeComparison();
                this.loadStateData();
            }
            service.hideLoader();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    loadStateData() {
        setTimeout(() => {
            try {
                this.state.scrollwidth = document.querySelector('.baby-size-comp').offsetWidth;
                this.state.halfwidth = this.state.scrollwidth / 2;
                this.state.weekwd = document.querySelector('.week-bar li').offsetWidth;
                this.state.weeks = document.querySelectorAll('.week-bar li');
                let a;
                this.state.typename = document.querySelector('.selected').innerText.split(' ');
                this.imagetype(this.state.typename[2]);
                for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
                    let wd = j * this.state.weekwd;
                    if (wd > this.state.halfwidth) {
                        a = j - 1;
                        break
                    }
                }
                for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
                    if (this.state.weeks[i].classList.contains('sel-week')) {
                        document.querySelector('.weeks-section').scrollLeft = ((this.state.weekwd * (i - a)));
                        break
                    }
                }

            } catch (err) {
                return "";
            }
            service.loadImages();
        }, 100)
    }

    getBabySizeComparisonData() {
        var postData = {}
        // var url = global.api_url + "comparison/getsizebytype";
        var url = global.api_ci_url + "BabySizeComparison/getBabySizeComparisonData";
        service.postServiceCall(url, postData).then((json) => {
            // console.log("json",json['result']);
            if (json['result']) {
                this.setState({
                    initialData: json,
                    babysizecomparisonData: json['result'],
                    currentweek: json['currentWeekNo'] ? json['currentWeekNo'] : 4,
                    imageUrl:json['result'][[json['currentWeekNo'] ? json['currentWeekNo'] : 4]-4]['fruitUrl']
                }, () => { this.loadBabySizeComparison(); this.loadStateData(); });
                localStorage.setItem('BabySizeComparisonData', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    loadBabySizeComparison() {
        try {
            setTimeout(() => {
                if (global.ftk != '' && global.userAry['childData']['UserChildList']) {
                    if ((global.userAry['childData']['UserChildList'].length != 0 && global.userAry['IsExpected']) && this.state.currentweek) {
                        document.querySelector("#week_" + this.state.currentweek).firstElementChild.firstElementChild.classList.add("weekcircle");
                        actions.weekInfo(this.state.currentweek, this, 4, 'bsc');
                        return !1
                    } else {
                        actions.weekInfo(4, this, 4, 'bsc');
                    }
                } else {
                    actions.weekInfo(4, this, 4, 'bsc');
                }

            }, 100)
            service.hideLoader();
            service.loadImages();
        } catch (error) {
            console.error(error);
            service.hideLoader();
        }
    }
    shareIcon(id) {
        console.log("shareOn================>", id.target.parentNode);
        if (document.querySelector('.sharing-options').style.display != "block") {
            document.querySelector('.sharing-options').style.display = "block";
        } else {
            document.querySelector('.sharing-options').style.display = "none";
        }
        if (window.innerWidth < 767) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
    shareTemplate(id, shareoption) {
        var imageUrl1=document.querySelector(".image-section").firstChild.src;
        if (global.ftk != '') {
            if (shareoption == "facebook" || shareoption == "whatsapp") {
                document.querySelector("meta[property='og\\:description']").content = "It is so fun comparing your fetus with fruit, animals and sweets.From poppy seed to Jackfruit, get a sense of your " + id + " weeks baby's approximate length and weight with our baby size comparison tool. Check now";
                document.querySelector("meta[property='og\\:image']").content = imageUrl1;

            } else if (shareoption == "twitter" || shareoption == "pintrest") {
                document.querySelector("meta[name='twitter\\:description']").content = "It is so fun comparing your fetus with fruit, animals and sweets.From poppy seed to Jackfruit, get a sense of your " + id + " weeks baby's approximate length and weight with our baby size comparison tool. Check now";
                document.querySelector("meta[name='twitter\\:image']").content = imageUrl1;
                document.querySelector("meta[name='twitter\\:title']").content = "PARENTING.FIRSTCRY.COM";
            }
            actions.shareArticle(shareoption, global.currentURL);
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    sortOption() {
        let element = document.querySelector(".size-options");
        element.classList.toggle("show");
    }
    sorttype(str) {
        document.querySelector('.selected').innerHTML = ('Size by ' + str);
        document.querySelector('.size-options').classList.remove('show');
        this.imagetype(str);
    }
    imagetype(imgtype) {
        let selectedtype = imgtype;
        let currwk;
        setTimeout(() => {
            for (let i = 0; i <= 36; i++) {
                if ((this.state.weeks[i]).classList.contains("sel-week")) {
                    currwk = parseInt((this.state.weeks[i]).innerText);
                    break
                }
            }
            if (selectedtype == "Fruit") {
                let frtname = this.state.babysizecomparisonData[currwk - 4].fruitName;
                document.querySelector('.image-name').innerHTML = frtname;
                let frturl = this.state.babysizecomparisonData[currwk - 4].fruitUrl;
                document.querySelector('.image-section img').src = frturl;
                document.querySelector('.image-section img').onerror = 'https://parenting.firstcry.com/tools/images/109298015-H-300x205.jpg';

            } else if (selectedtype == "Animal") {
                let anmlname = this.state.babysizecomparisonData[currwk - 4].animalName;
                document.querySelector('.image-name').innerHTML = anmlname;
                let anmlurl = this.state.babysizecomparisonData[currwk - 4].animalUrl;
                document.querySelector('.image-section img').src = anmlurl;
                document.querySelector('.image-section img').onerror = 'https://parenting.firstcry.com/tools/images/109298015-H-300x205.jpg';

            } else {
                let swtname = this.state.babysizecomparisonData[currwk - 4].sweetsName;
                document.querySelector('.image-name').innerHTML = swtname;
                let swturl = this.state.babysizecomparisonData[currwk - 4].sweetsUrl;
                document.querySelector('.image-section img').src = swturl;
                document.querySelector('.image-section img').onerror = 'https://parenting.firstcry.com/tools/images/109298015-H-300x205.jpg';
            }
        }, 10);

    }
    articleSlide(e) {
        if (e.target.parentElement.classList.contains("next-artl")) {
            let slidescroll = document.querySelector('.articles-slider').scrollLeft + document.querySelector(".slide-blk").offsetWidth;
            document.querySelector('.articles-slider').scrollTo({ top: 0, left: slidescroll, behavior: 'smooth' });
        } else {
            let slidescroll = document.querySelector('.articles-slider').scrollLeft - document.querySelector(".slide-blk").offsetWidth;
            document.querySelector('.articles-slider').scrollTo({ top: 0, left: slidescroll, behavior: 'smooth' });
        }
    }

    render() {
        return (

            <main className="main-container babySize">
                <Helmet
                    title="Baby Size Comparisons Week by Week: How big is your baby this week?"
                    meta={[
                        // <!-- Google / Search Engine Tags -->
                        { "itemprop": "name", "content": "PARENTING.FIRSTCRY.COM" },
                        { "itemprop": "description", "content": "It is so fun comparing your fetus with fruit, animals and sweets.From poppy seed to Jackfruit, get a sense of your " + this.state.currentweek + " weeks baby's approximate length and weight with our baby size comparison tool. Check now" },
                        { "itemprop": "image", "content": this.state.imageUrl },
                        // <!-- Facebook Meta Tags -->
                        { "property": "og:url", "content": global.currentURL },
                        { "property": "og:type", "content": "website" },
                        { "property": "og:title", "content": "PARENTING.FIRSTCRY.COM" },
                        { "property": "og:description", "content": "It is so fun comparing your fetus with fruit, animals and sweets.From poppy seed to Jackfruit, get a sense of your " + this.state.currentweek + " weeks baby's approximate length and weight with our baby size comparison tool. Check now" },
                        { "property": "og:image", "content": this.state.imageUrl },
                        // <!-- Twitter Meta Tags -->
                        { "name": "twitter:card", "content": "summary_large_image" },
                        { "name": "twitter:title", "content": "PARENTING.FIRSTCRY.COM" },
                        { "name": "twitter:description", "content": "It is so fun comparing your fetus with fruit, animals and sweets.From poppy seed to Jackfruit, get a sense of your " + this.state.currentweek + " weeks baby's approximate length and weight with our baby size comparison tool. Check now" },
                        { "name": "twitter:image", "content": this.state.imageUrl },

                        { "name": "description", "content": "Get details about week by week baby size compared by fruits and sweets like a baby length and weight as per the selected week at FirstCry Parenting" },
                        { "name": "keywords", "content": "Baby Size Comparisons" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Size Comparison</span>
                    </div>
                    <h1 className="B24_00">Baby Size Comparison Tools
                        <span className="useNameDyn"></span>
                    </h1>
                </div>
                <div className="sub-container left">
                    <div className="baby-size-comp data-container left">
                        <div className="baby-size-weeks">
                            <WeekSlider eleRef={this} WeekBdata={this.state.babysizecomparisonData} weekKey={'pregnancyWeek'} keyVal={4} tool={'bsc'} />
                        </div>
                        <div className="baby-size">
                            <div className="baby-size-btm">
                                <div className="image-section">
                                    <img src={require('../images/109298015-H-300x205.jpg')} />
                                    <span className="image-name M15_white"></span>
                                </div>
                                <div className="size-info">
                                    <div className="select-size" onClick={() => { this.sortOption() }}>
                                        <span className="selected M15_42" data-icon-font="f">Size by Fruit</span>
                                    </div>
                                    <ul className="size-options">
                                        <li className="R15_75 devsizebydropdown" id="size_by_fruit" onClick={() => { this.sorttype('Fruit') }}>Size by Fruit</li>
                                        <li className="R15_75 devsizebydropdown" id="size_by_animal" onClick={() => { this.sorttype('Animal') }}>Size by Animal</li>
                                        <li className="R15_75 devsizebydropdown" id="size_by_sweet" onClick={() => { this.sorttype('Sweet') }}>Size by Sweet</li>
                                    </ul>
                                    <div className="len-wt-block">
                                        <div className="len-wt left">
                                            <div className="R16_42">Length</div>
                                            <div className="baby-len B17_42"></div>
                                            <div className="R12_75">(Crown to Rump)</div>
                                        </div>
                                        <div className="border left"></div>
                                        <div className="len-wt left">
                                            <div className="R16_42">Weight</div>
                                            <span className="baby-wt B17_42"></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="article_cont">
                                    <span><a href={service.getRedirectUrl("/articles/baby-size-week-by-week-comparison-with-fruits-and-veggies/")} className="read-more-btn askB_1">Read more on Baby Size</a></span>
                                    <ShareIcon eleRef={this} tool={'BSC'} />
                                    <div className="share-overlay"></div>
                                    <div className="related-article">
                                        <div className="related-title M16_42">RELATED ARTICLES</div>
                                        <div className="articles-slider">
                                            <ul className="slider temp5 fl" style={{ width: this.state.sliderFullWidth }}>
                                                {this.state.babysizecomparisonData && this.state.babysizecomparisonData.length > 0 && this.state.babysizecomparisonData.map(result => this.state.clickwedWeek == parseInt(result['pregnancyWeek']) && result.articles && result.articles.length > 0 && result.articles.map((article, index) =>
                                                    <li key={index} className="slide slide-blk fl">
                                                        <a href={service.getRedirectUrl(article.articleUrl.replace("http://", "https://"))}>
                                                            <div className="article-img left">
                                                                <img className="devrelarticles" id={article.articleId} src={article.articleImage} />
                                                            </div>
                                                            <div className="article-txt left">
                                                                <span className="R14_42 devrelarticles" id={article.articleId} >
                                                                    {article.articleTitle}
                                                                </span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="arrows">
                                            <span className="next-artl" onClick={(e) => { this.articleSlide(e) }}>
                                                <span data-icon-font="h" className="icon"></span>
                                            </span>
                                            <span className="prev-artl" onClick={(e) => { this.articleSlide(e) }}>
                                                <span data-icon-font="g" className="icon"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}
export default BabySizeComparison;



// WEBPACK FOOTER //
// src/shared/tools/baby-size-comparison/BabySizeComparison.js